var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsArrowRightRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-right-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.43972 12.2038C4.72628 11.4207 4.56632 10.5248 4.95984 9.51584C5.35336 8.50693 6.05778 8.00165 7.07312 8L18.6759 8C19.6897 8 20.3941 8.50528 20.7891 9.51584C21.1841 10.5264 21.0242 11.4224 20.3092 12.2038L14.4516 18.6332C14.2263 18.8804 13.9822 19.0659 13.7193 19.1895C13.4565 19.3132 13.1749 19.375 12.8745 19.375C12.5741 19.375 12.2925 19.3132 12.0296 19.1895C11.7668 19.0659 11.5227 18.8804 11.2974 18.6332L5.43972 12.2038Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsArrowRightRounded);
export default __webpack_public_path__ + "static/media/material-symbols_arrow-right-rounded.c0f1fcf124ada6c5bf3098885d14a1e7.svg";
export { ForwardRef as ReactComponent };